<template>
  <div class="page-test">
    <div class="background-video">
      <video
        id="slide1-video"
        poster="https://assets.dinlab.cn/staticPage/img/dinlab_video_poster.jpg"
        preload="auto"
        x5-video-player-type="h5"
        x5-playsinline
        webkit-playsinline
        playsinline
        muted
        autoplay
        loop
      >
        <source
          src="https://assets.dinlab.cn/staticPage/img/dinlab_video_2k.mp4"
          type="video/mp4"
        />
      </video>
      <video
        id="slide1-video-mb"
        poster="https://assets.dinlab.cn/staticPage/img/dinlab_video_poster_mb.jpg"
        preload="auto"
        x5-video-player-type="h5"
        x5-playsinline
        webkit-playsinline
        playsinline
        muted
        autoplay
        loop
      >
        <source
          src="https://assets.dinlab.cn/staticPage/img/dinlab_video_2k_mb.mp4"
          type="video/mp4"
        />
      </video>
      <img
        id="slide1-img-mb"
        src="https://assets.dinlab.cn/staticPage/img/dinlab_video_poster_mb.gif"
        alt=""
      />
    </div>
  </div>
</template>

<script>
  import { TITLE_SUFFIX } from "../constant/constant";

  export default {
    name: "Test",
    data() {
      return {
        timer: false,
        home: "/home",
      };
    },
    created() {
      document.title = "与Din母星断开连接" + TITLE_SUFFIX;
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
      _isAndroid() {
        let flag = navigator.userAgent.match(/(Android)/i);
        return flag;
      },
    },
    mounted() {
      if (this._isMobile()) {
        console.log("Mobile");
        if (this._isAndroid()) {
          console.log("Android");
          document.querySelector("#slide1-video").remove();
          document.querySelector("#slide1-video-mb").remove();
        } else {
          console.log("Not Android");
          document.addEventListener(
            "WeixinJSBridgeReady",
            () => {
              document.querySelector("#slide1-video-mb").play();
            },
            false
          );
          document.querySelector("#slide1-video-mb").play();
          document.querySelector("#slide1-video").remove();
          document.querySelector("#slide1-img-mb").remove();
        }
      } else {
        console.log("Desktop");
        document.querySelector("#slide1-video-mb").remove();
        document.querySelector("#slide1-img-mb").remove();
      }
    },
  };
</script>

<style lang="scss">
  .page-test {
    background: #222;
    .background-video {
      overflow: hidden;
      position: fixed;
      opacity: 0.6;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      min-width: 100vw;
      min-height: 100vh;
      background-position: center;
      background-size: cover;
      backface-visibility: hidden;
      z-index: 1;
      video,
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        z-index: -100;
        transform: translateX(-50%) translateY(-50%);
        background-size: cover;
        z-index: -1;
      }
      #slide1-video-mb,
      #slide1-img-mb {
        width: 100%;
      }
    }
  }
</style>